import React from "react";
import AttendancePolicyComponent from "../../../AttendancePolicyComponent";

const ShiftStructureTab = ({
  darkMode,
  branchesList,
  departmentsList,
  designationsList,
  subDepartmentsList,
  gradesList,
  categoriesList,
}) => {
  return (
    <div className="p-4 text-[hsl(var(--ds-fg))] lg:p-6">
      <AttendancePolicyComponent
        darkMode={darkMode}
        mode="shift"
        branchesList={branchesList}
        departmentsList={departmentsList}
        designationsList={designationsList}
        subDepartmentsList={subDepartmentsList}
        gradesList={gradesList}
        categoriesList={categoriesList}
      />
    </div>
  );
};

export default ShiftStructureTab;
